import { useCallback, useEffect } from "react";
import isEqual from "react-fast-compare";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { FulfilledUpdateMethod, RequestState, REQUEST_STATE } from "../../dataTypes";
import { WebOrderContentsFilter } from "../dataTypes";
import { fetchWebOrderContents } from "../reducers/fetchWebOrderContents";
import { selectRequestState } from "../webOrderContentSelectors";
import { useValidateUserIsLoggedIn } from "../../utils/useValidateUserIsLoggedIn";
import { setError } from "../../dialog/dialogSlice";
import cloneDeep from "lodash.clonedeep";

let filterRef: WebOrderContentsFilter | undefined;
let requestStateRef: RequestState | undefined;

const useFetchWebOrderContents = () => {
  const dispatch = useAppDispatch();
  const result = useValidateUserIsLoggedIn();

  const requestState = useAppSelector(selectRequestState);

  if (requestStateRef === undefined) requestStateRef = requestState;

  useEffect(() => {
    requestStateRef = requestState;
  }, [requestState]);

  const loadWebOrderContents = useCallback(
    async ({
      filter,
      fulfilledUpdateMethod,
    }: {
      filter?: WebOrderContentsFilter;
      fulfilledUpdateMethod?: FulfilledUpdateMethod;
    }) => {
      if (result.isError) {
        dispatch(setError({ value: result.errorMessage }));
      } else {
        if (!isEqual(filter, filterRef) || requestStateRef !== REQUEST_STATE.PENDING) {
          requestStateRef = REQUEST_STATE.PENDING;
          filterRef = cloneDeep(filter);

          const { payload } = await dispatch(fetchWebOrderContents({ filter, fulfilledUpdateMethod }));

          if (payload && "page" in payload) {
            return payload.page.map(({ id }) => id);
          }
        }
      }
    },
    [dispatch, result],
  );

  return loadWebOrderContents;
};

export default useFetchWebOrderContents;
